import { getDashboardListAsync } from "dashboard/actions/list";

export const SET_FILTER = "SET_FILTER";
export const UNSET_FILTER = "UNSET_FILTER";

export const setFilter = filters => {
  return {
    type: SET_FILTER,
    payload: filters,
  };
};

export const unsetFilter = filters => {
  return {
    type: UNSET_FILTER,
    payload: filters,
  };
};

export const unsetAllFilters = () => {
  return (dispatch, getState) => {
    const { filters } = getState().dashboard;
    Object.keys(filters).forEach(filter => dispatch(unsetFilter(filter)));
  };
};

export const ADD_STATUS_FILTER = "ADD_STATUS_FILTER";
export const REMOVE_STATUS_FILTER = "REMOVE_STATUS_FILTER";

export const addStatusFilter = status => {
  return {
    type: ADD_STATUS_FILTER,
    payload: status,
  };
};

export const removeStatusFilter = status => {
  return {
    type: REMOVE_STATUS_FILTER,
    payload: status,
  };
};

export const SET_SORT = "SET_SORT";

export const setSort = sort => {
  return {
    type: SET_SORT,
    payload: sort,
  };
};

export const setSortFromDropdown = event => {
  return dispatch => {
    dispatch(setSort(event.target.value));
    dispatch(getDashboardListAsync());
  };
};
